import {INFO_SHOW} from "../types";

const infoShow= (data) => {
  return ({type: INFO_SHOW, payload: data});
};
export default infoShow;